import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Laptop, ArrowRight } from "@phosphor-icons/react";

export const LongstayStrip = () => {
  const { t } = useTranslation();
  return (
    <Link
      to="/estancias-largas"
      data-testid="longstay-strip"
      className="flex items-center justify-center gap-2.5 bg-[#E8D9BC] text-ink text-center py-3.5 px-6 text-[10px] md:text-[11px] uppercase tracking-[0.18em] hover:bg-terracotta hover:text-sand transition-colors"
    >
      <Laptop size={15} className="shrink-0" />
      {t("hero.badge")}
      <ArrowRight size={13} className="shrink-0" />
    </Link>
  );
};
